import React from 'react';

import {BulkActionResult} from 'src/components/bulk-tool';

import {DischargeAccountsEntitlementsResultModal} from './discharge-accounts-entitlements.result.modal';
import {
    clearResult,
    selectDischargeAccountsEntitlementsBulkUuid,
    selectDischargeAccountsEntitlementsShown,
    selectDischargeAccountsEntitlementsTask,
} from './discharge-accounts-entitlements.slice';


export const DischargeAccountsEntitlementsResult = () => (
    <BulkActionResult
        actionIdSelector={selectDischargeAccountsEntitlementsBulkUuid}
        actionTaskSelector={selectDischargeAccountsEntitlementsTask}
        actionShownSelector={selectDischargeAccountsEntitlementsShown}
        clearResult={clearResult}>
        {({id, onClose}) => (
            <DischargeAccountsEntitlementsResultModal id={id} onClose={onClose}/>
        )}
    </BulkActionResult>
);
